import clsx from 'clsx';

import {Icon} from './Icon';

import type {FontAwesomeIconProps} from '@fortawesome/react-fontawesome';

type Props = React.HTMLAttributes<HTMLSpanElement> & {
  icons: FontAwesomeIconProps[];
};
export function ComposedIcon({
  icons,
  className,
  ...props
}: Props): React.JSX.Element {
  return (
    <span
      {...props}
      // remove _composed-icon once styled-components is removed
      className={clsx(className, 'fa-layers fa-fw', '._composed-icon')}
    >
      {icons.map((icon, i) => (
        <Icon {...icon} key={i} />
      ))}
    </span>
  );
}
